/// <reference types="./EventUtils.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { EventType, ok, } from '@dossierhq/core';
import { buildSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryOne, queryRun } from '../QueryFunctions.js';
import { getTransactionTimestamp } from '../SqliteTransaction.js';
import { getSessionSubjectInternalId } from './SessionUtils.js';
export async function createEntityEvent(database, context, session, eventType, entityVersions, syncEvent) {
    const now = (syncEvent ? syncEvent.createdAt : getTransactionTimestamp(context.transaction)).toISOString();
    const uuid = syncEvent ? syncEvent.id : database.adapter.randomUUID();
    const createdBy = getSessionSubjectInternalId(session);
    const eventResult = await queryOne(database, context, buildSqliteSqlQuery(({ sql }) => {
        sql `INSERT INTO events (uuid, type, created_by, created_at)`;
        sql `VALUES (${uuid}, ${eventType}, ${createdBy}, ${now}) RETURNING id`;
    }));
    if (eventResult.isError())
        return eventResult;
    const eventsId = eventResult.value.id;
    const entitiesResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql, addValue }) => {
        sql `INSERT INTO event_entity_versions (events_id, entity_versions_id, published_name) VALUES`;
        const eventsValue = addValue(eventsId);
        for (const { entityVersionsId, publishedName } of entityVersions) {
            sql `, (${eventsValue}, ${entityVersionsId}, ${publishedName ?? null} )`;
        }
    }));
    if (entitiesResult.isError())
        return entitiesResult;
    return ok(undefined);
}
export async function createCreatePrincipalEvent(database, context, subjectInternalId, principalInternalId, syncEvent) {
    const now = (syncEvent ? syncEvent.createdAt : getTransactionTimestamp(context.transaction)).toISOString();
    const uuid = syncEvent ? syncEvent.id : database.adapter.randomUUID();
    const result = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
        sql `INSERT INTO events (uuid, type, created_by, created_at, principals_id)`;
        sql `VALUES (${uuid}, ${EventType.createPrincipal}, ${subjectInternalId}, ${now}, ${principalInternalId})`;
    }));
    if (result.isError())
        return result;
    return ok(undefined);
}
export async function createUpdateSchemaEvent(database, context, session, schemaVersionId, syncEvent) {
    const now = (syncEvent ? syncEvent.createdAt : getTransactionTimestamp(context.transaction)).toISOString();
    const uuid = syncEvent ? syncEvent.id : database.adapter.randomUUID();
    const createdBy = getSessionSubjectInternalId(session);
    const result = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
        sql `INSERT INTO events (uuid, type, created_by, created_at, schema_versions_id)`;
        sql `VALUES (${uuid}, ${EventType.updateSchema}, ${createdBy}, ${now}, ${schemaVersionId})`;
    }));
    if (result.isError())
        return result;
    return ok(undefined);
}
//# sourceMappingURL=EventUtils.js.map